import { render, staticRenderFns } from "./AddPart.vue?vue&type=template&id=a78b13d2&scoped=true"
import script from "./AddPart.vue?vue&type=script&lang=js"
export * from "./AddPart.vue?vue&type=script&lang=js"
import style0 from "./AddPart.vue?vue&type=style&index=0&id=a78b13d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78b13d2",
  null
  
)

export default component.exports